/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["path", {
  d: "m18 15-6-6-6 6",
  key: "153udz"
}]];
var ChevronUp = createLucideIcon("ChevronUp", __iconNode);
export { __iconNode, ChevronUp as default };